var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJzKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.52 32h-28a13 13 0 100 12h9.26L47 39.82 51.15 44H53l4.18-4.18L61.4 44h.12l6.84-6-6.84-6zm-46 9a3.5 3.5 0 112.455-1.025A3.5 3.5 0 0115.5 41h.02z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/JZ_Key.81a5bdef.svg";
export { SvgJzKey as ReactComponent };